import type { ChecklistFieldType as GeneratedChecklistFieldType } from './generated/checklist-models';

export type ChecklistFieldType = GeneratedChecklistFieldType;

export const ChecklistFieldType = {
  Text: 'Text' as ChecklistFieldType,
  TextInput: 'TextInput' as ChecklistFieldType,
} as const;
